import AICatalystInput from './AICatalystInput'

export default AICatalystInput
